<!-- @format -->
@let reviewCount = reviewCount$ | async;
@let highlyRatedForFeatures = highlyRatedForFeatures$ | async;
@if (reviewCount > 0 && highlyRatedForFeatures?.length > 0) {
	<div class="hmf-body-s hmf-body-m-m">
		<span class="hmf-display-inline-block hmf-pr-xxxs highly-rated-for-label"
			>Customer Highlighted</span
		>
		<button
			hmf-action-text
			variant="secondary"
			[size]="isMobile() ? 'small' : 'medium'"
			class="hmf-display-inline-block hmf-mb-s"
			(click)="openModal()">
			@for (item of highlyRatedForFeatures; track $index; let last = $last) {
				{{ item.feature | titlecase }}{{ !last ? '&emsp13;•&hairsp;' : '' }}
			}
		</button>
	</div>
}
